import template from "./index.html";
import "./index.less";
import { EVENT_LOGOUT } from "../../../constants";
import { globs } from "../../../services/globs";

//supportFeedback
export function controller(
	config, 
	$uibModal,
	api, 
	appState,
	loadingService,
	toastr, 
	$scope, 
	eventBus,
	$logger
) {
	const ctrl = this;

	ctrl.handleClose = handleClose;
	ctrl.onRemoteSupportClick = onRemoteSupportClick;
	ctrl.$onInit = onInit;
	ctrl.$onDestroy = handleClose;
	ctrl.sendMessage = sendMessage;

	ctrl.canViewVeslEmail = globs.feedback.vesl.email.read;
	ctrl.canViewRemoteSupport = globs.feedback.remoteSupport.read;

	function onInit() {
		ctrl.support = config.support;
		ctrl.permissions = appState.permissions;

		eventBus.register(EVENT_LOGOUT, () => { handleClose(); }, $scope);
	}

	function handleClose() {
		ctrl.modalInstance.close();
	}

	function onRemoteSupportClick() {
		ctrl.modalInstance.close();

		$uibModal.open({
			component: "remote-support"
		});
	}

	function sendMessage() {
		const params = {
			Message: ctrl.message
		};

		const promise = api.post("api/feedback", params).then(() => {
			toastr.success("Your message has been sent successfully!  We'll be getting back with you soon.");

			ctrl.modalInstance.close();
		});

		loadingService.watch(promise, "Sending Feedback...");
	}
}

export default angular
	.module("vesl.components.support-feedback", [])
	.component("supportFeedback", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			showClose: "<"
		}
	}).name;
